import React from "react";
import { motion } from "framer-motion";

const RotatingText = () => (
  <motion.div
    className="absolute inset-0 w-full h-full"
    animate={{ rotate: 360 }}
    transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
  >
    <svg viewBox="0 0 100 100">
      <path id="textPath" d="M50,50 m-40,0 a40,40 0 1,1 80,0 a40,40 0 1,1 -80,0" fill="none" />
      <text fill="black" fontSize="10" fontFamily="Cormorant, serif">
        <textPath xlinkHref="#textPath" startOffset="0%">
          ••••••••••••••••••••••••••••••••••••••••••••••••••••
        </textPath>
      </text>
    </svg>
  </motion.div>
);

export default function TransitionCircle() {
  return (
    <div className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-1/2 z-30">
     <motion.div
  initial={{ opacity: 0, scale: 0.8, y: 50 }}
  whileInView={{ opacity: 1, scale: 1, y: 0 }}
  transition={{ duration: 1.2, ease: "easeOut" }}
  viewport={{ once: true }}
  className="relative w-[140px] h-[140px] md:w-[160px] md:h-[160px] lg:w-[180px] lg:h-[180px] overflow-visible"
>

        {/* Outer Beige Circle */}
        <div className="absolute inset-0 bg-[#e8e9eb] rounded-full shadow-xl p-3 md:p-4 lg:p-5">
          {/* Inner White Circle */}
          <div className="w-full h-full rounded-full flex items-center justify-center bg-white text-center">
            {/* Replace text with image */}
            <img
              src="https://imgg.io/images/2025/11/04/14a9eb0e8961aa0ee4946c47c1b49131.png"
              alt="Circle Image"
              className="w-[70%] h-[100%] object-contain rounded-full"
            />
          </div>
        </div>

        {/* Rotating Text */}
        <RotatingText />
      </motion.div>
    </div>
  );
}
